function About() {

    return(
        <div className="bg-white text-center mb-10 justify-center">
            <div className="max-w-3xl mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gray-800">About</h2>
                <p className="text-slate-800">
                    At <span className="font-bold">Gigi’s Oasis</span>, we believe in the healing power of peace, touch, and self-care. Nestled in a serene space designed to transport you from the rush of everyday life, our spa is a sanctuary for those seeking rest, renewal, and radiance.
                    <br />
                    <br />
                    Whether you're here for a soothing massage, revitalizing facial, or just a moment to breathe, every service is crafted with care, professionalism, and a personal touch. Our mission is simple: to create an oasis where your body, mind, and spirit feel truly nurtured.
                    <br />
                    <br />
                    Step inside. Leave stress behind. You’ve arrived at your oasis.
                </p>
            </div>
        </div>
    );
}

export default About;